import { RightOutline } from "antd-mobile-icons";
import { useTranslation } from "react-i18next";
import {
  CustomCard,
  CustomRadio,
  CustomTable,
  RecordCards,
  TableTabs,
} from "../../../../components";
import { useMobile } from "../../../../context/MobileContext";
import { moneyFormat } from "../../../../plugins/numberFormat.js";
import { envChangeType, formatDate } from "../../../../plugins/utils.js";
import AmountArea from "../AmountArea";
import styles from "./style.module.scss";

const WalletRecord = ({
  data,
  items,
  activeTab,
  setActiveTab,
  columns,
  style,
  className,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  onClickCard,
  setCurrentPage,
  timeParam,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  const renderCardContent = (data) => {
    return (
      <>
        <div className={styles.left}>
          <div className={styles.money}>
            {t(`currency.symbol.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`) +
              moneyFormat(data?.money)}
          </div>
          <div className={styles.time}>{formatDate(data[timeParam])}</div>
        </div>
        <div className={styles.right} onClick={() => onClickCard(data)}>
          <div>{data?.audit_status_text}</div>
          <RightOutline className={styles.rightIcon} />
        </div>
      </>
    );
  };

  const renderContent = () => {
    if (isMobile) {
      return (
        <>
          <div className={styles.radio}>
            <CustomRadio
              items={items}
              value={activeTab}
              onClick={(e) => setActiveTab(Number(e.target.value))}
            />
          </div>
          <RecordCards
            data={data}
            content={renderCardContent}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            isFetchingNextPage={isFetchingNextPage}
          />
        </>
      );
    } else {
      return (
        <CustomCard
          style={{ borderRadius: " 0 0 6px 6px" }}
          title={
            <TableTabs
              defaultActiveKey={items[0]?.key}
              activeKey={activeTab}
              items={items}
              onTabClick={(key) => setActiveTab(key)}
            />
          }
        >
          <div className={className}>
            <CustomTable columns={columns} data={data?.data} setCurrentPage={setCurrentPage} />
          </div>
        </CustomCard>
      );
    }
  };

  return (
    <>
      <AmountArea
        money={moneyFormat(isMobile ? data?.pages[0].all || 0 : data?.all || 0)}
        style={{ ...style }}
      />
      {renderContent()}
    </>
  );
};

export default WalletRecord;
